import { apiClient } from '../../services/apiClient';

export interface BulkImportRow {
  email: string;
  password: string;
  groupe: string;
  modele?: string;
  nom?: string;
  prenom?: string;
}

export type BulkImportStatus = 'CREATED' | 'ENROLLED_EXISTING_USER' | 'ALREADY_ENROLLED' | 'ERROR';

export interface BulkImportRowResult {
  row: number;
  email: string;
  groupe: string;
  status: BulkImportStatus;
  message: string | null;
}

export interface BulkImportResponse {
  results: BulkImportRowResult[];
  createdCount: number;
  enrolledCount: number;
  errorCount: number;
}

export async function bulkImportRoster(rows: BulkImportRow[]): Promise<BulkImportResponse> {
  return apiClient<BulkImportResponse>('/admin/bulk-import', {
    method: 'POST',
    body: JSON.stringify({ rows }),
  });
}
